import Papa from "papaparse";

export const exportFile = (data, filename = "data") => {
  const csv = Papa.unparse(data);
  const csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const csvURL = URL.createObjectURL(csvData);
  const tempLink = document.createElement("a");
  tempLink.href = csvURL;
  tempLink.setAttribute("download", filename);
  document.body.appendChild(tempLink);
  tempLink.click();
  document.body.removeChild(tempLink);
};
